import { Map } from 'immutable'
import { SET_AUTH_DATA, SET_AUTH_PROCESSING, SET_AUTH_LOGIN_ERROR } from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_PROCESSING:
      return state.set('processing', action.payload)
    case SET_AUTH_DATA:
      return state.merge(Map({
        data: action.payload.data,
        processing: action.payload.processing,
      }))
    case SET_AUTH_LOGIN_ERROR:
      return state.set('loginError', action.payload)
    default:
      return state
  }
}
